export default function RecipeIntro({ text }) {
  if (!text) return null;

  return (
    <section className="py-6 px-6">
      <div className="max-w-4xl mx-auto text-center text-gray-600">
        <p>{text}</p>
      </div>
    </section>
  );
}
